module.exports = __webpack_public_path__ + "img/lion.be5030ca.webp";